import { Checkbox, TableCell, Typography } from "@mui/material"
import { ContentTypeTranslation } from "locale/es"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateContentAction } from "redux/reducers/contentReducer";
import { AppColors } from "resources/AppColors";

function ContentTableRows({ content }) {
  const [enabled, setEnabled] = useState(content.enabled ? true : false);

  const dispatch = useDispatch()

  const handleEnabled = (event) => {
    dispatch(updateContentAction({ id: content.id, enabled: event.target.checked }))
    setEnabled(event.target.checked);
  };

  return (
    <>
      <TableCell align="left">
        <Typography variant='body' noWrap sx={{ maxWidth: "200px", display: "inline-block" }}>{content.title}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body' noWrap sx={{ maxWidth: "200px", display: "inline-block" }}>{content.link}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{content?.businessPackage?.name}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{ContentTypeTranslation[content.contentType]}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{content.image || content.url ? "Si" : "No"}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body' noWrap sx={{ maxWidth: "150px", display: "inline-block" }}>{content.label}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body' noWrap sx={{ width: "150px", display: "inline-block" }}>{content.packageLabel}</Typography>
      </TableCell>
      <TableCell align="left">
        {typeof content.enabled === "boolean" &&
          <Checkbox
            checked={enabled}
            onChange={handleEnabled}
            style={{ color: AppColors.PRIMARY }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
      </TableCell>
    </>
  )
}

export default ContentTableRows